<template>
  <div v-if="images">
    <img
      v-if="images[indexImage]"
      :class="isSmall ? `apartment-image-type3-small`:`apartment-image-type3 shadow`"
      :src="images[indexImage].url()"
      :alt="images[indexImage].name()"
      :data-target="`#${prefix}-modal`"
    />
    <img
      v-else
      :class="isSmall ? `apartment-image-type3-small`:`apartment-image-type3 shadow`"
      src="/images/market-share.jpg"
      @click="zoomIn()"
    >
    <i class="fas fa-chevron-left icon-slide-left" @click="scrollBack()"></i>
    <div :id="`${prefix}-div-scroll`" class="div-slide-image">
      <img
        v-for="(image, index) in images"
        :class="index === indexImage ? `slide-image slide-image-selected`:`slide-image`"
        :id="`slider`+index"
        :key="index"
        :src="image.url()"
        :alt="image.name()"
        @click="()=>{indexImage = index}"
      />
    </div>
    <i class="fas fa-chevron-right icon-slide-right" @click="scrollNext()"></i>

    <div
      class="modal fade"
      :id="`${prefix}-modal`"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dailog-style" role="document">
        <div class="modal-content modal-content-style">
          <div class="modal-body modal-style">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <i class="fas fa-times icon-close"></i>
            </button>
            <i class="fas fa-chevron-left icon-slide-left-type3" @click="scrollBack()"></i>
            <img
              v-if="images[indexImage]"
              class="div-image-modal"
              :src="images[indexImage].url()"
              :alt="images[indexImage].name()"
            />
            <img
              v-else
              class="div-image-modal"
              src="/images/market-share.jpg"
            >
            <i class="fas fa-chevron-right icon-slide-right-type3" @click="scrollNext()"></i>
          </div>
        </div>
      </div>
    </div>
    <div :id="`${prefix}-modal`" class="modal modal-style">
      <i class="fas fa-times icon-close" @click="zoomOut()"></i>
      <img
        v-if="images[indexImage]"
        class="div-image-modal"
        @click="zoomIn()"
        :src="images[indexImage].url()"
        :alt="images[indexImage].name()"
      />
      <img
        v-else
        class="div-image-modal"
        src="/images/market-share.jpg"
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["images", "isSmall", "prefix"],

  mounted() {
    this.initData();
  },
  data() {
    return {
      indexImage: 0
    };
  },
  methods: {
    initData() {
      if (!this.images) this.images = null;
      if (!this.type) this.type = "1";
    },
    indexToNumber(index) {
      return Number(index);
    },
    scrollBack() {
      let div = document.getElementById(`${this.prefix}-div-scroll`);
      if (this.images) {
        if (this.indexImage - 1 < 0) {
          this.indexImage = this.images.length - 1;
        } else {
          this.indexImage = this.indexImage - 1;
        }
        div.scrollTo({
          left: 70 * this.indexImage,
          behavior: "smooth"
        });
      }
    },
    scrollNext() {
      let div = document.getElementById(`${this.prefix}-div-scroll`);
      if (this.images) {
        if (this.indexImage + 1 > this.images.length - 1) {
          this.indexImage = 0;
        } else {
          this.indexImage = this.indexImage + 1;
        }
        div.scrollTo({
          left: 70 * this.indexImage,
          behavior: "smooth"
        });
      }
    },
    zoomIn() {
      // document.getElementById(this.id + "modal").modal();
      console.log($(`${this.prefix}-modal`))
      $(`${this.prefix}-modal`).modal();
    },
    zoomOut() {}
  }
};
</script>

<style lang="scss" scoped>
$tinColorLigth: rgba(246, 139, 37, 0.8);
$tinColorLigth-hover: rgba(246, 139, 37, 0.5);
$image-slide-height: 50px;
$image-slide-width: 70px;
$shadow-selected: 0px 0px 4px 4px $tinColorLigth;
$shadow-hover: 0px 0px 4px 4px $tinColorLigth-hover;
$transition-time: 0.3s;

div.modal-style {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: auto;
  max-width: 70vw;
  max-height: 80vh;
  padding: 0;
  text-align: -webkit-center;
}
img.div-image-modal {
  object-fit: contain;
  width: 100%;
  height: auto;
  max-width: 70vw;
  max-height: 80vh;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.8);
  cursor: default;
}
.modal-dailog-style {
  margin: 0;
  background: none;
}
.modal-content-style {
  margin: 10vh 15vw;
  width: 70vw;
  height: 80vh;
  background: none;
  border: none;
}
i.icon-close {
  color: #fff;
  font-size: 50px;
  position: absolute;
  right: 0;
  top: 0;
  padding: 5px 10px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.7);
}
i.icon-close:hover {
  color: red;
}
.apartment-img {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 0.25em;
  padding-top: 56.25%;
}

.apartment-image-type2 {
  width: 100%;
  height: 500px;
  object-fit: cover;
}

.apartment-image-type3 {
  width: 100%;
  height: 70vh;
  object-fit: cover;
  cursor: zoom-in;
}
.apartment-image-type3-small {
  width: 100%;
  height: 40vh;
  object-fit: cover;
  cursor: zoom-in;
}
.slide-image {
  width: $image-slide-width;
  height: $image-slide-height;
  object-fit: cover;
  margin: 10px 10px;
  display: inline-block;
  -webkit-transition-duration: $transition-time;
  transition-duration: $transition-time;
}
.slide-image:hover {
  box-shadow: $shadow-hover;
  -webkit-transition-duration: $transition-time;
  transition-duration: $transition-time;
}

.slide-image-selected {
  box-shadow: $shadow-selected;
}

.div-slide-image {
  //   display: table-cell;
  height: 70px;
  max-width: 100%;
  margin: 5px 20px;
  //   padding: 0 20px;
  text-align: center;
  position: relative;
  vertical-align: middle;
  overflow-x: hidden;
  overflow-y: hidden;
  white-space: nowrap;
  scroll-behavior: smooth;
}

.icon-slide-left-type3 {
  position: absolute;
  padding: 20px;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;
  color: rgba(255, 255, 255, 0.2);
  font-size: 50px;
}
.icon-slide-left-type3:hover {
  border-radius: 10px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.2);
}
.icon-slide-right-type3 {
  position: absolute;
  padding: 20px;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;
  color: rgba(255, 255, 255, 0.2);
  font-size: 50px;
}
.icon-slide-right-type3:hover {
  border-radius: 10px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.2);
}
.icon-slide-left {
  position: absolute;
  left: 20px;
  bottom: 30px;
  cursor: pointer;
}
.icon-slide-right {
  position: absolute;
  right: 20px;
  bottom: 30px;
  cursor: pointer;
}
.apartment-section-title {
  border-bottom: black solid 3px;
  font-size: 1.25em;
}

.apartment-electronics {
  font-size: 1.25em;
}

.apartment-furnitures {
  font-size: 1.25em;
}

.apartment-item-list {
  background-color: #dedede;
  border: none;
}

.fa-minus-circle {
  color: red;
}
.rules {
  font-size: 1em;
}

#map {
  width: 100%;
  height: 100%;
  min-height: 400px;
  border-radius: 0.25em;
}

.actions-mobile {
  color: white;
  width: 280px;
  min-height: 120px;
  padding: 5px;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  bottom: 5px;
  right: 90px;
  text-align: center;
  border-radius: 0.25em;
}

.action-info {
  height: 100%;
  max-width: calc(100% - 50px);
}

.action-price {
  text-align: center;
  font-size: 1.5em;
}

.action-unit {
  text-align: right;
}

.action-btn-group {
  text-align: left;
  height: 100%;
}

.icon-item {
  text-align: center;
  margin: 10px;
}

.icon-img {
  width: 50px;
  height: 50px;
}

.map-container {
  border-radius: 0.25em;
}

.card {
  height: 100%;
}
</style>
